import {
  DialogContent,
  Dialog,
  DialogProps,
  DialogActions,
  Grid,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { PmiDialogTitle } from 'shell/components/shared/dialog/title';
import { styled } from '@mui/styles';
import { useFormik } from 'formik';
import PmiTextField from 'shell/components/shared/text-field';
import * as yup from 'yup';

export const modifyHistorianModalValidationSchema = yup.object({
  address: yup.string().nullable().required('Il campo è obbligatorio'),
  numberCivic: yup.string().nullable().required('Il campo è obbligatorio'),
  letterCivic: yup.string().nullable().required('Il campo è obbligatorio'),
});

export const PmiDialog = styled((props: DialogProps) => <Dialog {...props} />)((props) => ({
  '& .MuiDialog-paper': props.fullScreen
    ? {
        minWidth: 'unset',
        maxWidth: '100%',
      }
    : {
        minWidth: '50rem',
        maxWidth: '800px',
      },
}));

interface ModalInsertAddressProps {
  modalData: {
    address: string;
    numberCivic: string;
    letterCivic: string;
  };
  open: boolean;
  onClose: (open: boolean) => void;
  onSubmit: (values: { address: string; numberCivic: string; letterCivic: string }) => void;
}

const ModalInsertAddress = ({
  modalData,
  open,
  onClose,
  onSubmit,
}: ModalInsertAddressProps): React.ReactElement => {
  const form = useFormik({
    initialValues: modalData,
    validationSchema: modifyHistorianModalValidationSchema,
    onSubmit,
  });

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <PmiDialog
      open={open}
      onClose={() => onClose(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullScreen={fullScreen}
    >
      <PmiDialogTitle id="alert-dialog-title" backgroundColor="primary" color="white">
        Modifica Storico Indirizzi
      </PmiDialogTitle>
      <DialogContent style={{ padding: '30px 24px' }}>
        <Grid container spacing={2}>
          <Grid item xs={12} container spacing={2}>
            <Grid item xs={12} md={10}>
              <PmiTextField
                id="address"
                label="Indirizzo *"
                aria-label="Indirizzo"
                fullWidth
                helperText={form.errors.address}
                error={form.touched.address && Boolean(form.errors.address)}
                value={form.values.address || ''}
                onChange={(event) => form.setFieldValue('address', event.target.value)}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} md={4}>
            <PmiTextField
              id="numberCivic"
              label="Nr civico *"
              aria-label="Nr civico"
              fullWidth
              value={form.values.numberCivic || ''}
              onChange={(event) => form.setFieldValue('numberCivic', event.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <PmiTextField
              id="letterCivic"
              label="Lettera *"
              aria-label="Lettera"
              fullWidth
              value={form.values.letterCivic || ''}
              onChange={(event) => form.setFieldValue('letterCivic', event.target.value)}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <PmiButton
          variant="contained"
          color="primary"
          type="submit"
          onClick={() => {
            form.handleSubmit();
          }}
        >
          CONFERMA
        </PmiButton>
        <PmiButton variant="outlined" color="cdmBrand" type="button" onClick={() => onClose(false)}>
          ESCI
        </PmiButton>
      </DialogActions>
    </PmiDialog>
  );
};

ModalInsertAddress.displayName = 'Modal insert address';

export default ModalInsertAddress;
